$(document).ready(() => {
	const $planChoice = $('#trainer-plan');

	$planChoice.on('change', ev => {
		const domain  = ev.currentTarget.selectedOptions[0].dataset.domain;
		const setFee  = ev.currentTarget.selectedOptions[0].dataset.fee;
		const $domain = $('#custom_domain');
		const $fee    = $('#set-service-fee');

		('1' === domain) ? $domain.prop('disabled', false) : $domain.prop('disabled', true);
		('1' === setFee) ? $fee.fadeIn() : $fee.fadeOut();
	});

	$planChoice.trigger('change');
});
